import React from 'react';

import MiniCard from '@/modules/content/components/ContentCard/MiniCard';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';

import { useAdaptEvent } from '../../config';
import { EventCardProps } from '../types';

function EventCardDisplay(props: EventCardProps) {
  const { className, imageProps, noDescription } = props;
  const event = useAdaptEvent(props.event, ContentCardTypeEnum.Mini);

  return (
    <MiniCard
      baseContent={event}
      className={className}
      imageProps={imageProps}
      noDescription={noDescription}
    />
  );
}

export default EventCardDisplay;
